import moment from 'moment';
import qs from 'qs';
import axios from 'axios';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import DownloadIcon from 'mdi-react/DownloadIcon';
import Button from 'components/buttons/Button';
import { get, isEqual, isEmpty } from 'lodash';
import DateRangePicker, { ANCHOR_RIGHT } from 'components/forms/DateRangePicker';
import Calendar from 'icons/calendar';

import { DATE_FORMAT_SLASHES } from 'constants/config';
import { apiReportExportCSV } from 'constants/apiRouting';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';
import { DOWNLOAD_ANALYTICS_CSV } from 'constants/analytics';
import {
  resetReport,
  getReport,
} from 'redux/actions/reportActions';
import { getTimezoneAndUTCOffset, prepareFilterParams } from 'utils/report';
import {
  AccountsFilter,
  CampaignsFilter,
  PlanTypesFilter,
  CampaignManagersFilter,
  SequencesFilter,
  DynamicFilter,
  CampaignStatusFilter,
  EmailServiceProviderFilter,
} from 'components/filters';
import { getFilterStyle } from 'styles/const';
import classNames from 'classnames';
import { analyticsTrack } from '../../utils/analytics';
import { defaultNoticeConfig, notification } from '../../utils/notifications';
import BasicNotification from '../Notification';
import { CSV_REPORTS_ON_WAY_MESSAGE, UNEXPECTED_ERROR } from '../../constants/csv_download';


const LAST_WEEK_DATE_OPTION = { label: 'Last 7 days', value: 'weeks' };
const LAST_MONTH_DATE_OPTION = { label: 'Last 30 days', value: 'months' };
const LAST_YEAR_DATE_OPTION = { label: 'Last 365 days', value: 'years' };
const CUSTOM_DATE_OPTION = { label: 'Custom', value: 'custom_date_range' };
const AUTO_OPTION = { label: 'Auto', value: 'from_launch_to_completion' };


const DATE_OPTIONS = [
  LAST_WEEK_DATE_OPTION,
  LAST_MONTH_DATE_OPTION,
  LAST_YEAR_DATE_OPTION,
  CUSTOM_DATE_OPTION,
  AUTO_OPTION,
];

const styles = getFilterStyle;

const DYNAMIC_FILTER_OPTIONS = {
  campaignName: 'campaignName',
  campaignStatus: 'campaignStatus',
  esp: 'esp',
  manager: 'manager',
  account: 'account',
  planType: 'planType',
  sequence: 'sequence',
};

class Filters extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    getReport: PropTypes.func.isRequired,
    resetReport: PropTypes.func.isRequired,
    report: PropTypes.shape({
      loadingCSV: PropTypes.bool,
      report_charts: PropTypes.shape({}),
    }).isRequired,
    campaign: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
    user: PropTypes.shape({
      pk: PropTypes.number,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      isAuthenticated: PropTypes.bool,
      user_groups: PropTypes.array,
    }).isRequired,
    initFilterParams: PropTypes.shape({
      dateSelector: PropTypes.string,
      account__id: PropTypes.shape({}),
      campaign__id: PropTypes.shape({}),
      sequences__id: PropTypes.shape({}),
      email_service_provider_config__id: PropTypes.shape({}),
      campaign__campaign_manager__id: PropTypes.shape({}),
      subscription_type__id: PropTypes.shape({}),
      startDate: PropTypes.string,
      endDate: PropTypes.string,
    }).isRequired,
    hideCampaignManagersFilter: PropTypes.bool.isRequired,
    hideCampaignsFilter: PropTypes.bool.isRequired,
    hideAccountsFilter: PropTypes.bool.isRequired,
    hideSequencesFilter: PropTypes.bool.isRequired,
    hidePlanTypesFilter: PropTypes.bool.isRequired,
    hideESPFilter: PropTypes.bool.isRequired,
    isCampaignReportsTab: PropTypes.bool.isRequired,
    classes: PropTypes.shape({}).isRequired,
    includeAllCampaignOption: PropTypes.bool,
  }

  static defaultProps = {
    includeAllCampaignOption: false,
  };

  constructor(props) {
    super(props);
    this.defaultFilters = {
      account__id: this.props.initFilterParams && this.props.initFilterParams.account__id ?
        this.props.initFilterParams.account__id : [],
      campaign__campaign_manager__id: this.props.initFilterParams &&
        this.props.initFilterParams.campaign__campaign_manager__id ?
        this.props.initFilterParams.campaign__campaign_manager__id : [],
      campaign__id: this.props.initFilterParams && this.props.initFilterParams.campaign__id ?
        this.props.initFilterParams.campaign__id : [],
      sequences__id: this.props.initFilterParams && this.props.initFilterParams.sequences__id ?
        this.props.initFilterParams.sequences__id : [],
      subscription_type__id: this.props.initFilterParams && this.props.initFilterParams.subscription_type__id ?
        this.props.initFilterParams.subscription_type__id : [],
      email_service_provider_config__id: this.props.initFilterParams
        && this.props.initFilterParams.email_service_provider_config__id
        ? this.props.initFilterParams.email_service_provider_config__id
        : [],
    };
    const campaignId = get(props.initFilterParams, 'campaign__id.0.value', 0);
    const dateSelector = campaignId ? AUTO_OPTION : LAST_MONTH_DATE_OPTION;
    this.state = {
      anchorDateMenu: null,
      showDatepicker: false,
      filterParams: {
        dateSelector,
        ...this.defaultFilters,
        ...this.getDates(dateSelector),
      },
    };
  }

  componentDidMount() {
    const { initFilterParams } = this.props;
    this.props.resetReport();

    if (!initFilterParams || (initFilterParams.campaign__id || initFilterParams.account__id ||
      initFilterParams.campaign__campaign_manager__id || initFilterParams.subscription_type__id ||
      initFilterParams.sequences__id
    )) {
      this.fetchReport();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.initFilterParams, this.props.initFilterParams)) {
      this.setState({
        filterParams: {
          ...this.state.filterParams,
          ...nextProps.initFilterParams,
        },
      }, () => {
        this.fetchReport();
      });
    }
  }

  onResetSelectedFilter = (filter) => {
    const newParams = {};
    switch (filter) {
      case DYNAMIC_FILTER_OPTIONS.campaignName:
        newParams.campaign_id = null;
        break;
      case DYNAMIC_FILTER_OPTIONS.campaignStatus:
        newParams.campaign_status = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.manager:
        newParams.campaign__campaign_manager__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.account:
        newParams.account__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.planType:
        newParams.subscription_type__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.sequence:
        newParams.sequences__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.esp:
        newParams.email_service_provider_config__id = [];
        break;
      default:
        break;
    }
    this.setState({ filterParams: { ...this.state.filterParams, ...newParams } });
  }

  onDeleteFilter = (selectedFilter) => {
    const newState = this.state;

    switch (selectedFilter) {
      case DYNAMIC_FILTER_OPTIONS.campaignName:
        newState.filterParams.campaign__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.campaignStatus:
        newState.filterParams.campaign_status = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.manager:
        newState.filterParams.campaign__campaign_manager__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.account:
        newState.filterParams.account__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.planType:
        newState.filterParams.subscription_type__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.sequence:
        newState.filterParams.sequences__id = [];
        break;
      case DYNAMIC_FILTER_OPTIONS.esp:
        newState.filterParams.email_service_provider_config__id = [];
        break;
      default:
        break;
    }
    this.setState(newState, () => this.fetchReport());
  }

  onResetFilters = () => {
    const newState = this.state;
    newState.filterParams = {
      ...newState.filterParams,
      ...this.defaultFilters,
    };
    this.setState(newState, () => this.fetchReport());
  }

  getDates = (dateSelector) => {
    switch (dateSelector) {
      case LAST_WEEK_DATE_OPTION:
        return {
          startDate: moment().subtract(7, 'd').local().toDate(),
          endDate: moment().local().toDate(),
        };
      case LAST_MONTH_DATE_OPTION:
        return {
          startDate: moment().subtract(30, 'd').local(),
          endDate: moment().local(),
        };
      case LAST_YEAR_DATE_OPTION:
        return {
          startDate: moment().subtract(1, 'y').local().toDate(),
          endDate: moment().local().toDate(),
        };
      case AUTO_OPTION:
        // eslint-disable-next-line no-case-declarations
        const { campaign } = this.props;
        return {
          startDate: moment(campaign.launch_date).local().toDate(),
          endDate: campaign.completed_date
            ? moment(campaign.completed_date).local().toDate()
            : moment().local().toDate(),
        };
      case CUSTOM_DATE_OPTION:
        this.toggleDatepicker();
        break;
      default:
        break;
    }
    return {};
  }

  handleDateMenuClick = (event) => {
    this.setState({ anchorDateMenu: event.currentTarget });
  }

  handleDateMenuClose = () => {
    this.setState({ anchorDateMenu: null });
  }

  prepareParams = params => ({
    ...prepareFilterParams(params),
    ...getTimezoneAndUTCOffset(),
  })

  fetchReport = async () => {
    const preparedParams = this.prepareParams(this.state.filterParams);
    await this.props.getReport(preparedParams);
  }

  downloadCSV = async () => {
    const preparedParams = this.prepareParams(this.state.filterParams);
    const filterParams = {
      ...preparedParams,
      ...getTimezoneAndUTCOffset(),
    };
    analyticsTrack(DOWNLOAD_ANALYTICS_CSV, preparedParams, true);

    try {
      const res = await axios.get(apiReportExportCSV(), {
        params: filterParams,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      });
      if (res.status === 200) {
        notification.notice({
          content: <BasicNotification
            color="success"
            message={CSV_REPORTS_ON_WAY_MESSAGE}
          />,
          ...defaultNoticeConfig,
        });
      } else {
        notification.notice({
          content: <BasicNotification
            color="danger"
            message={UNEXPECTED_ERROR}
          />,
          ...defaultNoticeConfig,
        });
      }
    } catch (error) {
      notification.notice({
        content: <BasicNotification
          color="danger"
          message={UNEXPECTED_ERROR}
        />,
        ...defaultNoticeConfig,
      });
    }
  }

  toggleDatepicker = () => {
    this.setState({ showDatepicker: !this.state.showDatepicker });
  }

  handleChangeAccounts = (accounts) => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        account__id: accounts,
      },
    }, () => this.fetchReport());
  }

  handleChangeSubscriptionType = (subscriptionTypes) => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        subscription_type__id: subscriptionTypes,
      },
    }, () => this.fetchReport());
  }

  handleDateChangeFilter = (dateSelector) => {
    const { filterParams } = this.state;

    this.handleDateMenuClose();
    const { startDate, endDate } = this.getDates(dateSelector);

    this.setState({
      filterParams: {
        ...filterParams,
        dateSelector,
        startDate,
        endDate,
      },
    }, () => {
      if (startDate && endDate) {
        // fetchReport only if both startDate and endDate are present
        this.fetchReport();
      }
    });
  }

  handleDateChange = (startDate, endDate) => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        startDate,
        endDate,
      },
    }, () => {
      if (startDate && endDate) {
        this.toggleDatepicker();
        // fetchReport only if both startDate and endDate are present
        this.fetchReport();
      }
    });
  }

  handleChangeStartDate = (startDate) => {
    const { filterParams: { endDate }, filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        startDate: startDate ? moment(startDate).local().toDate() : null,
      },
    }, () => {
      if (startDate && endDate) {
        // fetchReport only if both startDate and endDate are present
        this.fetchReport();
      }
    });
  }

  handleChangeEndDate = (endDate) => {
    const { filterParams: { startDate }, filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        endDate: endDate ? moment(endDate).local().toDate() : null,
      },
    }, () => {
      if (startDate && endDate) {
        // fetchReport only if both startDate and endDate are present
        this.fetchReport();
      }
    });
  }

  handleChangeCampaigns = (campaigns) => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        campaign__id: campaigns,
      },
    }, () => this.fetchReport());
  }

  handleChangeCampaignStatus = (status) => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        campaign_status: status,
      },
    }, () => this.fetchReport());
  }

  handleChangeSequences = (sequences) => {
    const { filterParams } = this.state;

    this.setState({
      filterParams: {
        ...filterParams,
        sequences__id: sequences,
      },
    }, () => this.fetchReport());
  }

  handleChangeESPs = (esps) => {
    const { filterParams } = this.state;

    this.setState({
      filterParams: {
        ...filterParams,
        email_service_provider_config__id: esps,
      },
    }, () => this.fetchReport());
  }

  handleChangeManagers = (managers) => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        campaign__campaign_manager__id: managers,
      },
    }, () => this.fetchReport());
  }

  render() {
    const {
      classes, hideCampaignManagersFilter, hideCampaignsFilter, includeAllCampaignOption,
      hideAccountsFilter, hideSequencesFilter, hidePlanTypesFilter, hideESPFilter,
      initFilterParams, isCampaignReportsTab,
    } = this.props;
    const {
      filterParams, anchorDateMenu, showDatepicker,
    } = this.state;

    const campaignId = get(initFilterParams, 'campaign__id.0.value', 0);
    const accountId = get(initFilterParams, 'account__id.0.value', null);
    const dateMenuLabel = filterParams.dateSelector !== CUSTOM_DATE_OPTION || showDatepicker
      ? filterParams.dateSelector.label
      : `${filterParams.startDate.format(DATE_FORMAT_SLASHES)} - ${filterParams.endDate.format(DATE_FORMAT_SLASHES)}`;

    return (
      <React.Fragment>
        <div className="d-flex flex-sm-row mb-3 justify-content-between">
          <DynamicFilter
            onResetSelectedFilter={this.onResetSelectedFilter}
            onResetFilters={this.onResetFilters}
            options={[
              ...(!hideCampaignManagersFilter ? [
                {
                  key: DYNAMIC_FILTER_OPTIONS.manager,
                  menuLabel: 'Campaign Manager',
                  onDeleteFilter: this.onDeleteFilter,
                  component: <CampaignManagersFilter
                    value={filterParams.campaign__campaign_manager__id}
                    onChange={this.handleChangeManagers}
                  />,
                },
              ] : []),
              ...(!hideAccountsFilter ? [
                {
                  key: DYNAMIC_FILTER_OPTIONS.account,
                  menuLabel: 'Accounts',
                  onDeleteFilter: this.onDeleteFilter,
                  component: <AccountsFilter
                    value={filterParams.account__id}
                    onChange={this.handleChangeAccounts}
                  />,
                },
              ] : []),
              ...(!hideCampaignsFilter ? [
                {
                  key: DYNAMIC_FILTER_OPTIONS.campaignName,
                  menuLabel: 'Campaign Name',
                  onDeleteFilter: this.onDeleteFilter,
                  component: <CampaignsFilter
                    value={filterParams.campaign__id}
                    onChange={this.handleChangeCampaigns}
                    accountId={accountId}
                    includeAllOption={includeAllCampaignOption}
                  />,
                },
              ] : []),
              ...(!hideCampaignsFilter ? [
                {
                  key: DYNAMIC_FILTER_OPTIONS.campaignStatus,
                  menuLabel: 'Campaign Status',
                  onDeleteFilter: this.onDeleteFilter,
                  component: <CampaignStatusFilter
                    value={filterParams.campaign_status}
                    onChange={this.handleChangeCampaignStatus}
                  />,
                },
              ] : []),
              ...(!hidePlanTypesFilter ? [
                {
                  key: DYNAMIC_FILTER_OPTIONS.planType,
                  menuLabel: 'Subscriptions',
                  onDeleteFilter: this.onDeleteFilter,
                  component: <PlanTypesFilter
                    value={filterParams.subscription_type__id}
                    onChange={this.handleChangeSubscriptionType}
                  />,
                },
              ] : []),
              ...(!hideSequencesFilter ? [
                {
                  key: DYNAMIC_FILTER_OPTIONS.sequence,
                  menuLabel: 'Sequences',
                  onDeleteFilter: this.onDeleteFilter,
                  component: <SequencesFilter
                    value={filterParams.sequences__id}
                    onChange={this.handleChangeSequences}
                    campaign={campaignId}
                    isCampaignReportsTab={isCampaignReportsTab}
                  />,
                },
              ] : []),
              ...(!hideESPFilter ? [
                {
                  key: DYNAMIC_FILTER_OPTIONS.esp,
                  menuLabel: 'Sending Email',
                  onDeleteFilter: this.onDeleteFilter,
                  component: <EmailServiceProviderFilter
                    value={filterParams.email_service_provider_config__id}
                    onChange={this.handleChangeESPs}
                    campaignIds={campaignId ? [campaignId] : null}
                  />,
                },
              ] : []),
            ]}
          />
          <div className={classes.dateWrapper}>
            <div className="mr-2">
              <Button
                color="primary"
                variant="contained"
                type="text/csv"
                disabled={this.props.report.loadingCSV || isEmpty(this.props.report.report_charts)}
                onClick={this.downloadCSV}
                startIcon={<DownloadIcon />}
              >
                Download as csv
              </Button>
            </div>
            {!showDatepicker ?
              <React.Fragment>
                <button
                  className={classNames(classes.dateSelectorBtn, { open: anchorDateMenu })}
                  onClick={this.handleDateMenuClick}
                >
                  <Calendar className={classes.filterIcon} viewBox="0 0 17 17" />
                  {dateMenuLabel}
                </button>
                <Menu
                  id="date-menu"
                  anchorEl={anchorDateMenu}
                  keepMounted
                  open={Boolean(anchorDateMenu)}
                  onClose={this.handleDateMenuClose}
                >
                  {DATE_OPTIONS.filter(option => (campaignId ? Boolean : option !== AUTO_OPTION)).map(option => (
                    <MenuItem onClick={() => this.handleDateChangeFilter(option)}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Menu>
              </React.Fragment>
              :
              <DateRangePicker
                initialStartDate={filterParams.startDate}
                initialEndDate={filterParams.endDate}
                onChange={this.handleDateChange}
                minDate={null}
                maxDate={moment()}
                anchorDirection={ANCHOR_RIGHT}
                focusOnMounted
              />
            }
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(
    state => ({
      report: state.report,
      user: state.user,
      campaign: state.campaign,
    }),
    {
      resetReport,
      getReport,
    },
  ),
)(Filters);
